import { RateCurrency } from 'shared/price-utilities'

const Price = ({ value, currency, style, className = '' }) =>
    value != null && (
        <span className={className}>
            <RateCurrency value={value} currency={currency} />
        </span>
    )

export default Price
